import { createFeature, createReducer, on } from '@ngrx/store';
import { ContactUpdateError } from '../../interfaces';
import * as contactUpdateActions from './contact-update.actions';

export interface ContactUpdateState {
    isInitiating: boolean;
    isVerifying: boolean;
    verificationId: string | null;
    destinationMasked: string | null;
    pendingNewPhone: string | null;
    pendingExpectedLastModifiedDate: string | null;
    mobileUpdateSuccess: boolean;
    error: ContactUpdateError | null;
    errorType: ContactUpdateError['code'] | null;
}

const initialState: ContactUpdateState = {
    isInitiating: false,
    isVerifying: false,
    verificationId: null,
    destinationMasked: null,
    pendingNewPhone: null,
    pendingExpectedLastModifiedDate: null,
    mobileUpdateSuccess: false,
    error: null,
    errorType: null,
};

const reducer = createReducer(
    initialState,
    on(contactUpdateActions.InitiateMobilePhoneUpdateAction, (state, { newPhone, expectedLastModifiedDate }) => ({
        ...state,
        isInitiating: true,
        pendingNewPhone: newPhone,
        pendingExpectedLastModifiedDate: expectedLastModifiedDate,
        error: null,
        errorType: null,
    })),
    on(contactUpdateActions.InitiateMobilePhoneUpdateSuccessAction, (state, { verificationId, destinationMasked }) => ({
        ...state,
        isInitiating: false,
        verificationId,
        destinationMasked,
    })),
    on(contactUpdateActions.InitiateMobilePhoneUpdateFailureAction, (state, { error }) => ({
        ...state,
        isInitiating: false,
        error,
        errorType: error.code,
    })),
    on(contactUpdateActions.VerifyMobilePhoneAction, (state) => ({
        ...state,
        isVerifying: true,
        error: null,
        errorType: null,
    })),
    on(contactUpdateActions.VerifyMobilePhoneSuccessAction, (state) => ({
        ...state,
        isVerifying: false,
        mobileUpdateSuccess: true,
        verificationId: null,
        destinationMasked: null,
        pendingNewPhone: null,
        pendingExpectedLastModifiedDate: null,
    })),
    on(contactUpdateActions.VerifyMobilePhoneFailureAction, (state, { error }) => ({
        ...state,
        isVerifying: false,
        error,
        errorType: error.code,
    })),
    on(contactUpdateActions.ResetContactUpdateAction, () => initialState),
);

export const ContactUpdateFeatureName = 'ContactUpdate';

export const ContactUpdateFeature = createFeature({
    name: ContactUpdateFeatureName,
    reducer,
});
